import React from 'react'
import Topbar from '../Topbar/Topbar'
import { Container,Row,Col } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import  { useState, useEffect } from "react";
import { MdDelete } from "react-icons/md";
import axios from "axios";
  import Swal from "sweetalert2";
 

export default function Recoring() {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
const [setting, setSetting] = useState(false);
  const [staffData, setstaffData] = useState([]);
    const navi = useNavigate();
  
  const [customerdelete, setCustomerdelete] = useState(false);

  const [data, setData] = useState([]);

   const [filters, setFilters] = useState({
      taskAssignDate: "",
      taskStatus: "",
      approveStatus: "",
      taskName: "",
      taskType: "",
      taskPriority: "",
      deadline: "",
      assignedBy: "",
      completedPerson: "",
      approvedPerson: "",
      description: "",
      taskDenied: "",
      deniedReason: "",
    });

 const [columnVisibility, setColumnVisibility] = useState({
    taskAssignDate: true,
    taskStatus: true,
    approveStatus: true,
    taskName: true,
    taskType: true,
    taskPriority: true,
    deadline: true,
    assignedBy: true,
    completedPerson: true,
    approvedPerson: true,
    description: true,
    recurringStatus:true,
    assignedTo:true
    

  });


   const [statusCounts, setStatusCounts] = useState({
    active:0,
    inactive:0
    });
  

  const getTaskStatus = (status) => {
    if (!status) return "";
    switch (status.toLowerCase().trim()) {
      
      case "inactive":
        return "status-progress";
      case "active":
        return "status-completed";
      
      default:
        return "";
    }
  };


    const getRecurringStatus = (status) => {
    if (!status) return "";
    switch (status.toLowerCase().trim()) {
      
      case "inactive":
        return "status-progress";
      case "active":
        return "status-completed";
      
      default:
        return "";
    }
  };
   const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value.toLowerCase(), // Normalize input for case-insensitive search
    }));
  };

    const naviagte= useNavigate()
    const gotoListView =(e)=>
    {
        naviagte('/tasklistview')
    }

      const gotoaddRecovery =(e)=>
    {
        naviagte('/addrecurring')
    }


  const settingPopup = (e) => {
    e.preventDefault();
    setSetting(!setting);
  };

  const handleColumnVisibilityChange = (e) => {
    const { name, checked } = e.target;
    setColumnVisibility((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const filteredData = data.filter((customer) => {
    return Object.keys(filters).every((key) => {
      if (!filters[key]) return true;
      return String(customer[key]).toLowerCase().includes(filters[key]);

    });
  });

  const handleDelete = async (id) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "You want to delete this data!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
  });

  if (result.isConfirmed) {
    try {
      await axios.post(apiUrl + "delete-recurring-task", {
        _id: id,
      });

      Swal.fire("Deleted!", "Your data has been deleted.", "success");

      // ✅ Remove deleted item from table without refresh
      setData((prevData) => prevData.filter((item) => item._id !== id));
      
      setCustomerdelete(true);
    } catch (error) {
      Swal.fire("Error!", "Something went wrong while deleting.", "error");
      console.error("Delete Error:", error);
    }
  }
};



  
   useEffect(() => {
    axios
      .post(apiUrl + "view-recurring-task")
      .then((res) => {
        console.log("Task Data:", res.data);
        const fetchedData = res.data.message;
            const sortedData = [...fetchedData].reverse();

    console.log("Sorted data:", sortedData);
        setData(sortedData
        );
        const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD format
  
        const counts = {
          active: fetchedData.filter((c) => c.recurringStatus === "Active").length,
          inactive: fetchedData.filter((c) => c.recurringStatus === "InActive").length,
          
        };
  
        setStatusCounts(counts);
      })
      .catch((err) => {
        console.log("Error Fetching Tasks", err);
      });
  }, []);
  
 const gotoviewenquiry = (id) => {
  navi("/viewrecurring", {
    state: { id: id },
  });
};


  return (
    <div>
        <Topbar/>
        <Container>
   <Row className=" row-width">
          <Col md={2} sm={3}  xs={4}className="dashborder mt-4   mb-5 mx-2 " >
            <Row className="green-card">
              <p className="text-center box-txt " style={{ marginTop: "6px" }}>
                Open
              </p>
            </Row>
            <Row className="number">
              <h5 className="text-center pt-1"> {statusCounts.active}</h5>
            </Row>
          </Col>
         
          <Col md={2} sm={3} xs={4} className="dashborder mt-4 mb-5  mx-1">
            <Row className="grey-card ">
              <p className="text-center pt-1 box-txt">Inactive</p>
            </Row>
            <Row className="number">
              <h5 className="text-center pt-1"> {statusCounts.inactive}</h5>
            </Row>
          </Col>
          
         
      
         
        </Row>
            <Row class="mt-5">
                <Col md={6} className=''>
                <button class="black-btn mt-1" onClick={gotoListView}>Task List</button>
                               <button style={{width:"130px"}} class="black-btn  ms-4 mt-1" onClick={gotoaddRecovery}>Add Recurring</button>

               

               
               
               
                </Col>

                <Col className="mb-3 text-end">
                            <button className="black-btn black-btn1 btnadd">Export</button>
                            &emsp;&emsp;
                            <button onClick={settingPopup} className="black-btn black-btn1">
                              Settings
                            </button>
                            {setting && (
                              <div className="setting-popup-overlay">
                                <div className="setting-popup-container">
                                  <button className="setting-close-btn" onClick={settingPopup}>
                                    &times;
                                  </button>
                                  <div className="setting-popup-content">
                                    <div className="setting-checkbox-row">
                                      <label>
                                        <input
                                          type="checkbox"
                                          checked={Object.values(columnVisibility).every(
                                            (v) => v
                                          )}
                                          onChange={(e) => {
                                            const isChecked = e.target.checked;
                                            setColumnVisibility(
                                              Object.keys(columnVisibility).reduce(
                                                (acc, key) => {
                                                  acc[key] = isChecked;
                                                  return acc;
                                                },
                                                {}
                                              )
                                            );
                                          }}
                                        />
                
                                        <span
                                          className="checkbox-down"
                                          style={{ fontSize: "17" }}
                                        >
                                          Select All
                                        </span>
                                      </label>
                                    </div>
                                    <div className="setting-checkbox-grid">
                                      {Object.keys(columnVisibility).map((key) => (
                                        <label key={key} className="label-setting-popup">
                                          <input
                                            type="checkbox"
                                            name={key}
                                            checked={columnVisibility[key]}
                                            onChange={handleColumnVisibilityChange}
                                            className="checbox-popup"
                                          />
                                          <span className="checkbox-down1">
                                            {key
                                              .replace(/([a-z])([A-Z])/g, "$1 $2")
                                              .replace(/_/g, " ")
                                              .replace(/\b\w/g, (char) => char.toUpperCase())}
                                          </span>
                                        </label>
                                      ))}
                                    </div>
                
                                    <button
                                      className="setting-submit-btn"
                                      onClick={settingPopup}
                                    >
                                      Submit
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Col>
                
                
            </Row>

            <div className="scrolltable">
          <table className="table table-bordered">
            <thead className="table-th text-center">
              <tr>
                {/* {columnVisibility.taskAssignDate && (
                  <th className="table-th-content">Task Assign Date</th>
                )} */}
               

                  {columnVisibility.recurringStatus && (
                  <th className="table-th-content">Recurring Status</th>
                )}
                {/* {columnVisibility.approveStatus && (
                  <th className="table-th-content">Approve Status</th>
                )} */}
                {columnVisibility.taskName && (
                  <th className="table-th-content">Task Name</th>
                )}
                {columnVisibility.taskType && (
                  <th className="table-th-content">Task Type</th>
                )}
                {columnVisibility.taskPriority && (
                  <th className="table-th-content">Task Priority</th>
                )}
                {columnVisibility.deadline && (
                  <th className="table-th-content">Deadline</th>
                )}
                {columnVisibility.assignedBy && (
                  <th className="table-th-content">Assigned By</th>
                )}
                {columnVisibility.assignedTo && (
                  <th className="table-th-content">Assigned To</th>
                )}
               
                {columnVisibility.approvedPerson && (
                  <th className="table-th-content">Approved Person</th>
                )}
                {columnVisibility.description && (
                  <th className="table-th-content">Description</th>
                )}
                

                  <th className="table-th-content">Delete</th>
                
              </tr>
            </thead>

            <tbody className="tr:nth-child(even)">
              <tr>
                {/* {columnVisibility.taskAssignDate && (
                  <td>
                    <input
                      className="table-search background-change"
                      name="taskAssignDate"
                      onChange={handleFilterChange}
                      placeholder="Search"
                      type="date"
                    />
                  </td>
                )} */}
             
                 {columnVisibility.recurringStatus && (
                  <td>
                    <select
                      className="table-search background-change"
                      name="recurringStatus"
                      placeholder="Search"
                      onChange={handleFilterChange}
                    >
                      <option>Select</option>
                      <option value="Active">Active</option>
                      <option value="InActive">InActive</option>
                      
                    </select>
                  </td>
                )}
                {/* {columnVisibility.approveStatus && (
                  <td>
                    <select
                      className="table-search background-change"
                      name="approveStatus"
                      placeholder="Search"
                      onChange={handleFilterChange}
                    >
                      <option>Select</option>
                      <option value="Open">Open</option>
                      <option value="Progress">Progress</option>
                      <option value="Cancelled">Cancelled</option>
                      <option value="Completed">Completed</option>
                    </select>
                  </td>
                )} */}
                {columnVisibility.taskName && (
                  <td>
                    <input
                      className="table-search background-change"
                      name="taskName"
                      onChange={handleFilterChange}
                      placeholder="Search"
                      type="text"
                    />
                  </td>
                )}
                {columnVisibility.taskType && (
                  <td>
                    <input
                      className="table-search background-change"
                      name="taskType"
                      onChange={handleFilterChange}
                      placeholder="Search"
                      type="text"
                    />
                  </td>
                )}
                {columnVisibility.taskPriority && (
                  <td>
                    <select
                      className="table-search background-change"
                      name="taskPriority"
                      placeholder="Search"
                      onChange={handleFilterChange}
                    >
                      <option>Select</option>
                      <option value="Low">Low</option>
                      <option value="High">High</option>
                    </select>
                  </td>
                )}

                {columnVisibility.deadline && (
                  <td>
                    <input
                      className="table-search background-change"
                      name="taskAssignDate"
                      onChange={handleFilterChange}
                      placeholder="Search"
                      type="date"
                    />
                  </td>
                )}
                {columnVisibility.assignedBy && (
                  <td>
                    <select
                      className="table-search background-change"
                      name="assignedBy"
                      placeholder="Search"
                      onChange={handleFilterChange}
                    >
                      <option value="">Select</option>
                      {staffData.map((staff) => (
                        <option key={staff.staffId} value={staff.staffName}>
                          {staff.staffName}
                        </option>
                      ))}
                    </select>
                  </td>
                )}
                {/* {columnVisibility.completedPerson && (
                  <td>
                    <select
                      className="table-search background-change"
                      name="completedPerson"
                      placeholder="Search"
                      onChange={handleFilterChange}
                    >
                      <option value="">Select</option>
                      {staffData.map((staff) => (
                        <option key={staff.staffId} value={staff.staffName}>
                          {staff.staffName}
                        </option>
                      ))}
                    </select>
                  </td>
                )} */}
                {columnVisibility.approvedPerson && (
                  <td>
                    <select
                      className="table-search background-change"
                      name="approvedPerson"
                      placeholder="Search"
                      onChange={handleFilterChange}
                    >
                      <option value="">Select</option>
                      {staffData.map((staff) => (
                        <option key={staff.staffId} value={staff.staffName}>
                          {staff.staffName}
                        </option>
                      ))}
                    </select>
                  </td>
                )}
                {columnVisibility.description && (
                  <td>
                    <input
                      className="table-search table-search-date background-change"
                      type="text"
                      name="description"
                      onChange={handleFilterChange}
                      placeholder="Search"
                    />
                  </td>
                )}
                {/* {columnVisibility.taskDenied && (
                  <td>
                    <input
                      className="table-search table-search-date background-change"
                      type="text"
                      name="taskDenied"
                      onChange={handleFilterChange}
                      placeholder="Search"
                    />
                  </td>
                )}
                {columnVisibility.deniedReason && (
                  <td>
                    <input
                      className="table-search-date table-search background-change"
                      type="text"
                      name="deniedReason"
                      onChange={handleFilterChange}
                      placeholder="Search"
                    />
                  </td>
                )} */}
                <td></td>
              </tr>

              {filteredData.map((d, i) => (
                <tr key={i}>
                  {/* {columnVisibility.taskAssignDate && (
                    <td  onClick={()=>{gotoviewenquiry(d._id)}}>{d.assignDateTime}</td>
                  )} */}
                  {/* {columnVisibility.taskStatus && (
                    <td>
                      <span className={getTaskStatus(d.taskStatus)}>
                        {d.taskStatus}
                      </span>
                    </td>
                  )} */}

                  {columnVisibility.recurringStatus && (
                    <td onClick={()=>{gotoviewenquiry(d._id)}}>
                      <span className={getRecurringStatus(d.recurringStatus)}>
                        {d.recurringStatus}
                      </span>
                    </td>
                  )}
                  {/* {columnVisibility.approveStatus && (
                    <td>
                      
                        {d.approveStatus}
                     
                    </td>
                  )} */}

                  {columnVisibility.taskName && <td>{d.taskName}</td>}
                  {columnVisibility.taskType && <td>{d.taskType}</td>}
                  {columnVisibility.taskPriority && <td>{d.taskPriority}</td>}
                  {columnVisibility.deadline && <td>{d.deadlineDays}</td>}
                  {columnVisibility.assignedBy && <td>{d.assignedBy.staffName}</td>}
                  {columnVisibility.completedPerson &&  <td>
    {d.assignedTo.map((person) => person.staffName).join(", ")}
  </td>}
                 

                  {columnVisibility.approvedPerson && (
                    <td>
                     
                      {d.approvePerson.map((person) => person.staffName).join(", ")}
                  
                    </td>
                  )}
                  {columnVisibility.description && <td>{d.description}</td>}
                  {/* {columnVisibility.taskDenied && <td>{d.taskDenied?.taskDeniedBy}</td>}
                  {columnVisibility.deniedReason && <td>{d.taskDenied?.taskDeniedReason}</td>} */}
{/* 
                  {columnVisibility.delete && ( */}
                    <td>
                      <button
                        onClick={() => handleDelete(d._id)}
                        style={{ backgroundColor: "none" }}
                        className="deletebtn text-center"
                      >
                        <MdDelete size={20} />
                      </button>
                    </td>
                  {/* )} */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        </Container>
    </div>
  )
}
